<template>
  <nav id="nav">
    <router-link to="/" @click.native="toggleMap">
      <p id="brand">CREATING HOME</p>
    </router-link>
    <!-- <b-dropdown id="dropdown" aria-role="list">
      <template #trigger="{ active }">
        <b-button
          label="Languages"
          type="small"
          size="is-small"
          :outlined="true"
          :inverted="true"
          :icon-right="active ? 'menu-up' : 'menu-down'"
        />
      </template>

      <b-dropdown-item
        class="dropdown-clickable"
        aria-role="listitem"
        @click="updateLanguage('en')"
      >
        English
      </b-dropdown-item>
      <b-dropdown-item
        class="dropdown-clickable"
        aria-role="listitem"
        @click="updateLanguage('es')"
      >
        Spanish
      </b-dropdown-item>
    </b-dropdown> -->
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  computed: {
    language() {
      return this.$store.state.language;
    },
    currentAudio() {
      return this.$store.state.currentAudio;
    },
    playState() {
      return this.$store.state.audioPlayState;
    }
  },
  methods: {
    updateLanguage(language) {
      this.$store.commit("setLanguage", language);
    },
    toggleMap() {
      this.$store.commit("setMapVisibility", true);
      this.$store.commit("setFocus", true);
      if (this.playState) {
        this.$store.commit("setAudioPlayState", false);
        this.currentAudio.pause();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#nav {
  color: $darkGrey;
  background-color: $white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
}

#brand {
  position: relative;
  padding: 1rem;
}

#dropdown {
  position: relative;
  padding: 1rem;
}

button {
  color: $darkGrey;
}

.dropdown-clickable {
  color: black;
}
</style>
